<template>
    <a-image :width="props.width" :height="props.height" :src="state.imgurl" @error="handleError"
        style="border-bottom: 1px solid #dedede;"></a-image>
</template>
<script lang="ts" setup>
import { reactive, ref, onMounted, onUnmounted, h, watch } from 'vue'
import { message, Modal, Table } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import baseServicePlus from '@/utils/http/axiosPlus'
const emit = defineEmits(['change'])
const props = defineProps({
    src: {
        type: String,
        default: ''
    },
    width: {
        type: [Number, String],
        default: null
    },
    height: {
        type: [Number, String],
        default: null
    }
})
interface IState {
    imgurl: string
    loading: boolean
    reloadInterval: any
    loadlist: any[]
}
const state = reactive<IState>({
    imgurl: '',
    loading: false,
    reloadInterval: {
        timer: null,
        time: 2000
    },
    loadlist: []
})
onMounted(() => {
    if (props.src) {
        state.imgurl = String(props.src)
    } else {
        state.imgurl = ''
    }
})
onUnmounted(() => {
    if (state.reloadInterval.timer) {
        clearInterval(state.reloadInterval.timer)
    }
})
//如果图片加载失败
const handleError = (e) => {
    if (state.imgurl.indexOf('storage/public/uploads/') > 0) {
        let restoreUrl = 'public/uploads/' + state.imgurl.split('storage/public/uploads/')[1]
        restoreUrl = restoreUrl.split('?')[0]
        checkHaveFile(restoreUrl)
    }
}
//检查是否有存储
const checkHaveFile = (url) => {
    if (state.loadlist.indexOf(url) > -1) {
        return
    }
    state.loadlist.push(url)
    state.loading = true
    let requestParam = {
        url: '/admin/v1/restoreShow',
        method: 'post',
        data: {
            url: url,
            axiosStep: 3
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            if (res.data == 1) {
                //文件已存在，直接刷新image
                refreshImage()
            } else if (res.data == 2) {
                // 文件不存在，需要去解冻
                setTimeout(() => {
                    reloadFile(url)
                }, 50);
            }
        })
        .catch((res) => {
            // if (res.msg) {
            //     message.error(res.msg)
            // } else {
            //     message.error('图片加载失败')
            // }
        })
        .finally(() => {
            state.loading = false
        })
}
const refreshImage = () => {
    state.imgurl = state.imgurl.split('?')[0]
    state.imgurl = state.imgurl + '?time=' + new Date().getTime()
}
const reloadFile = (url) => {
    state.loading = true
    let requestParam = {
        url: '/admin/v1/restoreShow',
        method: 'post',
        data: { url: url }
    }
    baseServicePlus(requestParam, state.reloadInterval)
        .then((res: any) => {
            refreshImage()
        })
        .catch((res) => {
            // message.error(res.msg)
        })
        .finally(() => {
            state.loading = false
        })
}
watch(
    () => props.src,
    (val) => {
        if (val) {
            if (props.src) {
                state.imgurl = String(props.src)
            } else {
                state.imgurl = ''
            }
        }
    },
    {
        deep: true,
        immediate: true
    }
)
</script>
